import Reflux from 'reflux';
import ItemSetData from 'shared/data/ItemSet';
import ItemSetListData from 'shared/data/ItemSetList';

const async = { asyncResult: true };

const NewGlobalElementModalActions = Reflux.createActions({
  populate: {},
  populateSelection: {},
  changeActiveElementSet: {},
  changeActiveTag: {},
  populateItemSet: async,
  clear: {},
  publish: {},
  createGlobalElementFromShowRow: async,
});

NewGlobalElementModalActions.createGlobalElementFromShowRow.listenAndPromise(
  ItemSetData.createGlobalElementFromShowRow,
);

NewGlobalElementModalActions.populateItemSet.listenAndPromise(
  ItemSetListData.get,
);

export default NewGlobalElementModalActions;
